import { CarrierRequestStatus } from '@zorro/clients';
import { Select, SelectProps } from '@zorro/design-system/v2/Select';
import { carrierRequestStatusLabelConfig } from '@zorro/types';
import { FormErrorMessage } from '@zorro/web/design-system';
import {
  FieldPath,
  FieldValues,
  UseControllerProps,
  useController,
} from 'react-hook-form';

const CARRIER_REQUEST_STATUS_SELECT_OPTIONS = Object.values(
  CarrierRequestStatus
)
  .filter((option) => option !== CarrierRequestStatus.NOT_APPLICABLE)
  .map((option) => ({
    value: String(option),
    label: carrierRequestStatusLabelConfig[option],
  }));

type Props<
  TFieldValues extends FieldValues,
  TName extends FieldPath<TFieldValues>,
> = UseControllerProps<TFieldValues, TName> & {
  selectProps?: SelectProps;
};

export const ChangeCarrierRequestStatusInput = <
  TFieldValues extends FieldValues,
  TName extends FieldPath<TFieldValues>,
>({
  selectProps,
  ...formField
}: Props<TFieldValues, TName>) => {
  const {
    field,
    formState: { errors },
  } = useController(formField);

  return (
    <>
      <Select
        {...field}
        label="Carrier request status"
        placeholder="Select carrier request status"
        data={CARRIER_REQUEST_STATUS_SELECT_OPTIONS}
        {...selectProps}
      />

      <FormErrorMessage fieldName={formField.name} errors={errors} />
    </>
  );
};
